"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var vdl_prefix_1 = require("../util/vdl-prefix");
var localizers_1 = require("../util/localizers");
var format = function (props) { return localizers_1.date.getFormat('footer', props.format); };
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function () {
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.value);
            }
        };
        return _this;
    }
    Footer.prototype.render = function () {
        var now = this.props.value;
        var formatted = localizers_1.date.format(now, format(this.props), this.props.locale);
        return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('calendar__footer') },
            React.createElement("button", { tabIndex: -1, className: vdl_prefix_1.vdlPrefix('calendar__footer__button'), "aria-disabled": !!this.props.disabled, "aria-readonly": !!this.props.readOnly, disabled: this.props.disabled, onClick: this.handleOnClick }, formatted)));
    };
    Footer.propTypes = {
        value: PropTypes.instanceOf(Date),
        locale: PropTypes.string,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        format: PropTypes.string
    };
    return Footer;
}(React.PureComponent));
exports.Footer = Footer;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/calendar/footer.js
// module id = 522
// module chunks = 0 1 2 3 4 5 6